// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  map: {
    height: '100%',
    position: 'relative',
  },
  mapSearchOverlay: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 10,
  },
  mapSearchOverlayLayers: {
    position: 'absolute',
    top: theme.spacing(11),
    left: theme.spacing(2),
    zIndex: 10,
  },
  transparentLayer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  loadingModal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, .4)',
    top: 0,
    left: 0,
    color: '#eee',
    textAlign: 'center',
    '& p': {
      top: '45%',
      left: '45%',
      fontSize: '1.5em',
      position: 'absolute',
    },
  },
});

export default styles;
